const groups = [
  {
    day: "今天",
    date: "09.06",
    items: [
      {
        tag: "档案新增",
        tone: "primary",
        title: "主播「电竞KK」早期直播言论页已归档",
        desc: "补入 2019 至 2021 年间多场直播文字记录，含原始表述与后续回应说明，供前后对照。",
        meta: "主播 · 电竞KK",
        time: "14:32",
        cm: "318",
      },
      {
        tag: "时间线更新",
        tone: "accent",
        title: "网红「桃桃酱」商务合作时间线顺到今年 8 月",
        desc: "新增两起合作相关的发布与删除记录，事件背景与关联方关系进一步清晰。",
        meta: "网红 · 桃桃酱",
        time: "11:05",
        cm: "256",
      },
      {
        tag: "关联补充",
        tone: "secondary",
        title: "演员「沈嘉茉」新增 2 位关联人物",
        desc: "根据公开资料补充同组主创与经纪往来两条线索，档案信息更完整。",
        meta: "明星 · 沈嘉茉",
        time: "09:47",
        cm: "142",
      },
    ],
  },
  {
    day: "昨天",
    date: "09.05",
    items: [
      {
        tag: "档案新增",
        tone: "primary",
        title: "歌手「顾言泽」巡演相关争议节点补档",
        desc: "把分散在多个平台的发言与回应按时间串起，新增 3 条核心节点说明。",
        meta: "明星 · 顾言泽",
        time: "22:18",
        cm: "620",
      },
      {
        tag: "素材征集",
        tone: "accent",
        title: "征集「麻辣丸子」更早带货素材",
        desc: "现档案以 2022 年后为主，早期内容待补充，已在投稿入口挂起需求。",
        meta: "网红 · 麻辣丸子",
        time: "16:03",
        cm: "89",
      },
    ],
  },
  {
    day: "09月04日",
    date: "09.04",
    items: [
      {
        tag: "时间线更新",
        tone: "secondary",
        title: "财经大V「林岳」合同细节已整理入档",
        desc: "结合公开可查的签约信息整理成时间线，标注待证实部分，方便二次核对。",
        meta: "公众人物 · 林岳",
        time: "20:44",
        cm: "203",
      },
      {
        tag: "档案新增",
        tone: "primary",
        title: "公益人「许砚舟」组织公示信息归档",
        desc: "整理公示期信息与各方回应，条目按时间与主题分区存放。",
        meta: "公众人物 · 许砚舟",
        time: "13:12",
        cm: "76",
      },
    ],
  },
];

const toneMap: Record<string, { chip: string; dot: string }> = {
  primary: { chip: "bg-primary-100 text-primary-700", dot: "bg-primary-500" },
  accent: { chip: "bg-accent-100 text-accent-800", dot: "bg-accent-500" },
  secondary: { chip: "bg-secondary-100 text-secondary-800", dot: "bg-secondary-500" },
};

export default function FlashTimeline() {
  return (
    <section id="flash" className="mx-auto w-full max-w-6xl scroll-mt-24 px-4 py-10 md:py-14">
      <div className="flex flex-col items-start justify-between gap-3 sm:flex-row sm:items-end">
        <div>
          <p className="mb-1 flex items-center gap-2 text-xs font-semibold tracking-widest text-primary-500">
            <span className="inline-block h-px w-6 bg-primary-400" />
            FLASH
          </p>
          <h2 className="font-heading text-2xl font-black text-foreground-950 md:text-3xl">
            快讯时间线 · 按最新顺序看瓜
          </h2>
          <p className="mt-2 max-w-2xl text-sm text-foreground-500">
            档案每天都有新增和补全，时间线把「新增、更新、征集」三类动作串起来，隔几天回来不迷路。
          </p>
        </div>
        <a href="#archive" className="flex items-center gap-1 whitespace-nowrap text-sm text-primary-600 hover:text-primary-700">
          查看全部更新 <i className="ri-arrow-right-line" />
        </a>
      </div>

      <div className="mt-7 grid gap-6 lg:grid-cols-[1fr_340px]">
        {/* 时间线列 */}
        <div className="relative">
          <span className="absolute bottom-2 left-[9px] top-2 w-px bg-background-200" aria-hidden />
          <div className="space-y-8">
            {groups.map((g) => (
              <div key={g.day}>
                <div className="mb-3 flex items-center gap-3">
                  <span className="relative z-10 flex h-5 w-5 items-center justify-center">
                    <span className="h-3 w-3 rounded-full border-2 border-primary-500 bg-background-50" />
                  </span>
                  <span className="text-sm font-semibold text-foreground-900">{g.day}</span>
                  <span className="text-xs text-foreground-400">{g.date}</span>
                </div>
                <div className="space-y-3 pl-8">
                  {g.items.map((it) => {
                    const t = toneMap[it.tone] ?? toneMap.primary;
                    return (
                      <article
                        key={it.title}
                        className="group rounded-xl border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-200 hover:bg-background-100/60"
                      >
                        <div className="flex items-center gap-2">
                          <span className={`rounded-full px-2.5 py-0.5 text-[11px] font-medium ${t.chip}`}>{it.tag}</span>
                          <span className="text-xs text-foreground-400">{it.time}</span>
                          <span className={`ml-auto h-1.5 w-1.5 rounded-full ${t.dot}`} />
                        </div>
                        <h3 className="mt-2.5 cursor-pointer text-[17px] font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700">
                          {it.title}
                        </h3>
                        <p className="mt-1.5 text-sm leading-6 text-foreground-500">{it.desc}</p>
                        <div className="mt-3 flex items-center gap-3 text-xs text-foreground-400">
                          <span className="flex items-center gap-1">
                            <i className="ri-user-line" /> {it.meta}
                          </span>
                          <span className="flex items-center gap-1 transition-colors hover:text-primary-600">
                            <i className="ri-chat-3-line" /> {it.cm} 条围观
                          </span>
                        </div>
                      </article>
                    );
                  })}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* 侧栏：入口/下载更醒目 */}
        <aside className="space-y-4">
          <div className="overflow-hidden rounded-2xl bg-gradient-to-br from-primary-600 to-primary-500 p-5 text-background-50">
            <span className="inline-flex rounded-full bg-background-50/20 px-2.5 py-0.5 text-[11px] font-medium">订阅式追更</span>
            <h3 className="mt-3 font-heading text-lg font-bold leading-snug">
              开「围观提醒」<br />更新不再错过
            </h3>
            <p className="mt-2 text-sm leading-6 text-background-100/90">
              关注某个人物后，他的档案一有新增，会第一时间推送给你，无需反复刷新。
            </p>
            <a href="#talk" className="mt-4 flex items-center justify-center gap-1 whitespace-nowrap rounded-full bg-background-50 px-4 py-2 text-sm font-semibold text-primary-600 transition-colors hover:bg-background-100">
              <i className="ri-download-2-line" /> 下载 App 开启
            </a>
          </div>

          <div className="rounded-2xl border border-background-200 bg-background-100/70 p-5">
            <h3 className="flex items-center gap-2 text-sm font-bold text-foreground-900">
              <i className="ri-megaphone-line text-accent-600" /> 值班小编说
            </h3>
            <p className="mt-2.5 text-sm leading-6 text-foreground-600">
              每条档案我们都标了「已核实 / 待证实 / 争议中」三档，你看到拿不准的，欢迎在条目下留言补证，一起把时间线捋顺。
            </p>
            <div className="mt-3 flex flex-wrap gap-1.5">
              {["严格按来源", "时间线清晰", "不对号入座"].map((s) => (
                <span key={s} className="rounded-full bg-background-50 px-2.5 py-1 text-xs text-foreground-500">
                  {s}
                </span>
              ))}
            </div>
          </div>
        </aside>
      </div>
    </section>
  );
}